module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_j_melanistic.f1e1f9c9.png";